import { render, staticRenderFns } from "./DetailPermohonanKonfirmasi.vue?vue&type=template&id=fa6e9ed4&"
import script from "./DetailPermohonanKonfirmasi.vue?vue&type=script&lang=js&"
export * from "./DetailPermohonanKonfirmasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports